import { dto_selected_merchant_or_product } from "../../classes/dto-selected-merchant-or-product";
import { dto_Customer } from "../../classes/dto-customer";
import { postMethod } from "../post";
import { dto_common } from "../../classes/dto-common";
import { Api } from "../../config/config";

//#region MasterCategoryForCategoryPage
export const api_CategoryPageLoadGroceryCategory = () => {
  var url = `${Api}/?ControllerName104=/ApiHome`;
  return postMethod(
    url,
    '{ "SERVICENAME":"LoadGrocceryCategory","MID":' +
      dto_selected_merchant_or_product.MID +
      ',"CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}",
  );
};
